import { Injectable } from "@angular/core";

@Injectable({
	providedIn: "root",
})
export class CommonVariablesService {
	/* baseURL: string = 'http://qaipds1.cloware.in/'; */
	/* baseURL: string = 'https://ipds1.cloware.in/'; */
	/* baseURL: string = 'https://ipdsbeta1.tataaig.com/'; */
	// baseURL: string = 'https://uatipds1.cloware.in/'; 
	/* baseURL: string = 'http://tagicmarine.cloware.in/'; */
	   baseURL: string = "/";
	/* baseURL: string = 'https://sellonline.tataaig.com/'; */
	/* baseURL: string = 'http://localhost:4200/'; */

	gcPolicyNoFromHeaderSearch = "";
	//Ipds1
	selected: string;
	productId: string = "";
	declarationProductId = "";
	uwLOneGrpCode = "";
	uwLTwoGrpCode = "";
	uwLThreeGrpCode = "";
	helpdeskGrpCode = "";
	user_management_product = "emarine";
	role_admin = "admin";
	role_hub = "hub";
	role_helpdesk = "opshelpdesk";
	role_uw = "underwriter";
	role_claims = "claims";
	role_sales_rm = "csm";
	roles_ops = "ops";
	role_adminview = "adminview";
	/* user_management_product = 'openpolicymarinecargo';
	role_admin = 'marineadmin';
	role_hub = 'marinehub';
	role_helpdesk = 'marineopshelpdesk';	
	role_uw = 'Underwriter';
	role_claims = 'marineclaims'; */
	/* productId: string = 'M000000000004';
	declarationProductId = 'M000000000005';
	uwLOneGrpCode = 'G000000003258';
	uwLTwoGrpCode = 'G000000003259';
	uwLThreeGrpCode = 'G000000003260';  
	user_management_product = 'openpolicymarinecargo';
	role_admin = 'marineadmin';
	role_hub = 'marinehub';
	role_helpdesk = 'marineopshelpdesk';	
	role_uw = 'Underwriter';
	role_claims = 'marineclaims'; */
	//UATIpds1
	/* productId: string = 'M100000000001';
	declarationProductId = 'M100000000002';
	uwLOneGrpCode = 'G000000000665';
	uwLTwoGrpCode = 'G000000000666';
	uwLThreeGrpCode = 'G000000000667';
	user_management_product = 'openpolicymarinecargo';
	role_admin = 'marineadmin';
	role_hub = 'marinehub';
	role_helpdesk = 'marineopshelpdesk';	
	role_uw = 'Underwriter'; */
	//TM
	/* productId: string = 'M000000000007';
	declarationProductId = 'M00000002';
	uwLOneGrpCode = 'G000000000515';
	uwLTwoGrpCode = 'G000000000515';
	uwLThreeGrpCode = 'G000000000515';
	user_management_product = 'openpolicymarinecargo';
	role_admin = 'emarine_admin';
	role_hub = 'emarine_hub';
	role_helpdesk = 'emarine_ops';
	role_uw = 'Underwriter'; */
	//QandA
	/* productId: string = 'M000000000056';
	declarationProductId = 'M000000000127'; 
	uwLOneGrpCode = 'G000000003637';
	uwLTwoGrpCode = 'G000000003638';
	uwLThreeGrpCode = 'G000000003639';
	user_management_product = 'openpolicymarinecargo';
	role_admin = 'marineadmin';
	role_hub = 'marinehub';
	role_helpdesk = 'marineopshelpdesk';	
	role_uw = 'Underwriter'; */
	//QAIPDS
	/* productId: string = 'M100000000004';
	declarationProductId = 'M100000000005'; 
	uwLOneGrpCode = 'G000000001242';
	uwLTwoGrpCode = 'G000000001243';
	uwLThreeGrpCode = 'G000000001244';
	user_management_product = 'openpolicymarinecargo';
	role_admin = 'marineadmin';
	role_hub = 'marinehub';
	role_helpdesk = 'marineopshelpdesk';	
	role_uw = 'Underwriter'; */
}
